// Import: Middleware Action & Custom Types
import { CLEAN_EDIT_STORES, CLEAN_EDIT_STORES_ERROR } from '_models/redux/types';

// Action function
export const cleanIsEditStores = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_EDIT_STORES,
      payload: undefined,
    });
  } catch (e) {
    console.error(e);
    dispatch({
      type: CLEAN_EDIT_STORES_ERROR,
      payload: undefined,
    });
  }
};
